import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// @ components
import { OKButton } from 'commonsComponents/OKButton';
import withFiltersFeatures from './withFiltersFeatures'
const OKModal = require('components/commons/OKModal/OKModal');

class Filters extends PureComponent {
    constructor(props) {
        super(props);
         this.state = {
            isOpen: false
         }
    }
    
    handleOnFilter = () => {
        const { filtersId, onFilter, setApplied } = this.props;
        setApplied(filtersId);
        onFilter()
        this.handleTogglefilters()
    }

    handleTogglefilters = () => {
        const { isOpen } = this.state;
        this.setState({isOpen: !isOpen})
    }

    handleOnOpenModal = () => {
        this.props.onOpenModal()
        this.handleTogglefilters()
    }

    handleOnCloseModal = () => {
        this.props.onCloseModal()
        this.handleTogglefilters()
    }

    render() {
        const { isOpen } = this.state;
        const { title, renderFilters } = this.props;

        return (
            <div>
                <OKButton modifier="task" onClick={this.handleOnOpenModal}>
                    <i className="icon-filtrar" />
                </OKButton>
                <OKModal
                    content={renderFilters(this)}
                    contentOverflow="auto"
                    footerType="navigation"
                    isOpen={isOpen}
                    onCloseCallback={this.handleOnCloseModal}
                    onPrimaryButtonClick={this.handleOnFilter}
                    primaryButtonText="accountDebitsFilter-buttonApply"
                    onSecondaryButtonClick={this.handleOnCloseModal}
                    secondaryButtonText="accountDebitsFilter-buttonCancel"
                    shouldCloseOnOverlayClick={false}
                    title={title}
                    type="filter"
                />
            </div>
        );
    }
}

Filters.defaultProps = {
    onOpenModal: () => {},
    onCloseModal: () => {},
};

Filters.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    extraClass: PropTypes.string,
    filtersId: PropTypes.string.isRequired,
    immFilters: PropTypes.object,
    initFilter: PropTypes.func.isRequired,
    onFilter: PropTypes.func.isRequired,
    onOpenModal: PropTypes.func,
    onCloseModal: PropTypes.func,
    setApplied: PropTypes.func.isRequired,
    title: PropTypes.string,
    renderFilters: PropTypes.func.isRequired,
};

export default withFiltersFeatures(Filters);